import React from "react";

// Página pública (sin login ni layout): Soporte de CentralSaludApp.
// Se enlaza como URL de soporte desde App Store Connect (Apple lo exige).

const C = { verde: "#3cbf9a", verdeOscuro: "#2da080", tinta: "#1f2933", gris: "#5b6770", borde: "#e6eaee" };

const S = {
  body: { margin: 0, background: "#f3f5f7", color: C.tinta, fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif', lineHeight: 1.6, minHeight: "100vh" },
  wrap: { maxWidth: 820, margin: "0 auto", padding: "0 0 64px" },
  header: { background: C.verde, color: "#fff", padding: "36px 28px" },
  brand: { fontSize: 22, fontWeight: 700 },
  sub: { fontSize: 14, color: "#e3f6ef", marginTop: 4 },
  bar: { height: 4, background: C.verdeOscuro },
  main: { background: "#fff", padding: "36px 28px" },
  h1: { fontSize: 24, margin: "0 0 18px" },
  h2: { fontSize: 17, margin: "28px 0 8px", color: C.verdeOscuro },
  h3: { fontSize: 15, margin: "18px 0 4px" },
  p: { fontSize: 15 },
  ul: { paddingLeft: 20, fontSize: 15 },
  a: { color: C.verdeOscuro },
  contact: { display: "flex", flexWrap: "wrap", gap: 14, margin: "18px 0" },
  cardLink: { flex: "1 1 220px", border: `1px solid ${C.borde}`, borderLeft: `4px solid ${C.verde}`, borderRadius: 8, padding: "16px 18px", textDecoration: "none", color: C.tinta, background: "#fbfdfc" },
  label: { display: "block", fontSize: 12, color: C.gris, textTransform: "uppercase", letterSpacing: ".5px" },
  value: { display: "block", fontSize: 16, fontWeight: 700, color: C.verdeOscuro, marginTop: 4 },
  footer: { textAlign: "center", color: C.gris, fontSize: 13, padding: 24 },
};

export default function SoporteApp() {
  return (
    <div style={S.body}>
      <div style={S.wrap}>
        <header style={S.header}>
          <div style={S.brand}>CentralSalud</div>
          <div style={S.sub}>Soporte de la aplicación</div>
        </header>
        <div style={S.bar} />
        <main style={S.main}>
          <h1 style={S.h1}>Soporte</h1>
          <p style={S.p}>¿Necesita ayuda con la aplicación <strong>CentralSalud</strong>? Nuestro equipo está disponible para asistirle con el acceso, los pedidos, la gestión de inventario o cualquier incidencia técnica.</p>

          <div style={S.contact}>
            <a style={S.cardLink} href="mailto:soporte@centralsalud.es">
              <span style={S.label}>Correo de soporte</span>
              <span style={S.value}>soporte@centralsalud.es</span>
            </a>
            <a style={S.cardLink} href="https://www.centralsalud.es">
              <span style={S.label}>Sitio web</span>
              <span style={S.value}>www.centralsalud.es</span>
            </a>
          </div>

          <h2 style={S.h2}>Cómo obtener ayuda</h2>
          <p style={S.p}>Escríbanos a <a style={S.a} href="mailto:soporte@centralsalud.es">soporte@centralsalud.es</a> indicando:</p>
          <ul style={S.ul}>
            <li>El nombre de su clínica o centro.</li>
            <li>Una descripción del problema o consulta.</li>
            <li>Si es posible, una captura de pantalla.</li>
          </ul>
          <p style={S.p}>Le responderemos lo antes posible en horario laboral.</p>

          <h2 style={S.h2}>Preguntas frecuentes</h2>
          <h3 style={S.h3}>No puedo iniciar sesión</h3>
          <p style={S.p}>Verifique su usuario y contraseña. Si el problema continúa, contacte con soporte para restablecer su acceso.</p>
          <h3 style={S.h3}>La cámara no escanea los códigos</h3>
          <p style={S.p}>Asegúrese de haber concedido el permiso de cámara a la aplicación desde los ajustes de su dispositivo y de tener buena iluminación.</p>
          <h3 style={S.h3}>¿Cómo solicito cambios en mi cuenta o centro?</h3>
          <p style={S.p}>Escríbanos a soporte y gestionaremos los cambios con su clínica matriz.</p>

          <h2 style={S.h2}>Privacidad</h2>
          <p style={S.p}>Consulte nuestra <a style={S.a} href="/privacidad-app">Política de Privacidad</a>.</p>
        </main>
        <footer style={S.footer}>
          © CentralSalud · <a style={S.a} href="https://www.centralsalud.es">www.centralsalud.es</a>
        </footer>
      </div>
    </div>
  );
}
